// extracted by mini-css-extract-plugin
module.exports = {"NavHeader":"ConfigurationScreenNavbar__NavHeader__2B_SD"};